<template>
  <div :style="`z-index:${popuShow ? '100': '-1'}`" class="popup-box" @touchmove.prevent>
      <div :style="`opacity: ${show?0.47:0};`" class="mask" @click="$emit('submit')"></div>
      <slot></slot>
  </div>
</template>

<script>
export default {
    props: {
        show: {
            type: [Boolean, null],
            default: null
        }
    },
    data(){
        return{
            popuShow: false
        }
    },
    watch:{
        show: {
            handler(val){
                console.log(val)
                const that = this
                !val ? setTimeout(_=>{
                    this.popuShow = val
                }, 400) : this.popuShow = val
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.popup-box{
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    .mask{
        position: absolute;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        background: #403b3b;
        transition: all .5s;
    }
}

</style>